import TemperatureUnit from 'owa-service/lib/contract/TemperatureUnit';
import type { TemperatureUnit as GqlTemperatureUnit } from 'owa-graph-schema';

export default function convertGqlTemperatureUnitToOwsTemperatureUnit(
    type: GqlTemperatureUnit
): TemperatureUnit {
    switch (type) {
        case 'Celsius':
            return TemperatureUnit.Celsius;
        case 'Fahrenheit':
            return TemperatureUnit.Fahrenheit;
        case 'None':
        default:
            return TemperatureUnit.Default;
    }
}
